const products = [
    {
        id: 0,
        category: '스페셜 도시락',
        name: '소불고기 도시락',
        subTitle: '호불호 없는 완벽한 단짠의 정석, 정성 가득한 한 끼', 
        price: 11900,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogiBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 780,
            carb: 90,
            protein: 32,
            fat: 28,
        }
    },
    {
        id: 1,
        category: '스페셜 도시락',
        name: '연어구이 도시락',
        subTitle: '담백하게 구워낸 고품격 연어, 건강한 에너지를 채우다',
        price: 12900,
        productImg: process.env.PUBLIC_URL + '/images/SalmonBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SalmonBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 820,
            carb: 85,
            protein: 35,
            fat: 34,
        }
    },
    {
        id: 2,
        category: '스페셜 도시락',
        name: '고기한상 도시락',
        subTitle: '육즙 가득 고기들의 향연, 입안 가득 든든한 풍미',
        price: 13400,
        productImg: process.env.PUBLIC_URL + '/images/MeatFeastBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/MeatFeastBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 950,
            carb: 95,
            protein: 38,
            fat: 42,
        }
    },
    {
        id: 3,
        category: '스페셜 도시락',
        name: '별미한상 도시락',
        subTitle: '특별한 날에 어울리는 구성, 당신을 위한 별미 한상',
        price: 14900,
        productImg: process.env.PUBLIC_URL + '/images/ChefSpecialBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChefSpecialBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1000,
            carb: 100,
            protein: 40,
            fat: 45,
        }
    },
    {
        id: 4,
        category: '스페셜 도시락',
        name: '담백한상 도시락',
        subTitle: '자극적이지 않은 깔끔한 맛, 몸이 편안해지는 구성',
        price: 15900,
        productImg: process.env.PUBLIC_URL + '/images/LightHealthyBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/LightHealthyBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 900,
            carb: 90,
            protein: 42,
            fat: 30,
        }
    },
    {
        id: 5,
        category: '스페셜 도시락',
        name: '간장제육 도시락',
        subTitle: '은은한 간장 베이스의 감칠맛, 매일 먹어도 질리지 않는 맛',
        price: 10000,
        productImg: process.env.PUBLIC_URL + '/images/SoySaucePorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SoySaucePorkBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 850,
            carb: 92,
            protein: 34,
            fat: 35,
        }
    },
    {
        id: 6,
        category: '스페셜 도시락',
        name: '고추장제육 도시락',
        subTitle: '화끈한 불향과 매콤한 유혹, 지친 하루에 에너지를 더하다',
        price: 10600,
        productImg: process.env.PUBLIC_URL + '/images/SpicyPorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpicyPorkBox_Detail.png',
        isMD: false,
        defaultScore: 800,
        cartCount: 150,       
        nutrition: {
            kcal: 900,
            carb: 95,
            protein: 33,
            fat: 38,
        }
    },
    {
        id: 7,
        category: '스페셜 도시락',
        name: '등심돈까스 도시락',
        subTitle: '바삭한 튀김옷 속 꽉 찬 고기, 정통 돈까스의 든든함',
        price: 11200,
        productImg: process.env.PUBLIC_URL + '/images/PorkCutletBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/PorkCutletBox_Detail.png',
        isMD: true,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1050,
            carb: 110,
            protein: 32,
            fat: 48,
        }
    },
    {
        id: 8,
        category: '간편 도시락',
        name: '새우튀김불백 도시락',
        subTitle: '바다의 바삭함과 육지의 달콤함, 조화로운 맛의 설계',
        price: 11500,
        productImg: process.env.PUBLIC_URL + '/images/ShrimpBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/ShrimpBulgogiBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 980,
            carb: 105,
            protein: 34,
            fat: 45,
        }
    },
    {
        id: 9,
        category: '간편 도시락',
        name: '탕수육불백 도시락',
        subTitle: '쫄깃한 탕수육과 소불고기의 만남, 풍성한 식감의 조화',
        price: 11500,
        productImg: process.env.PUBLIC_URL + '/images/SweetSourPorkBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SweetSourPorkBulgogiBox_Detail.png',
        isMD: false,
        defaultScore: 500,
        cartCount: 220,
        nutrition: {
            kcal: 1050,
            carb: 115,
            protein: 33,
            fat: 48,
        }
    },
    {
        id: 10,
        category: '간편 도시락',
        name: '새우튀김제육 도시락',
        subTitle: '매콤한 제육에 고소한 새우튀김, 질릴 틈 없는 조합',
        price: 11500,
        productImg: process.env.PUBLIC_URL + '/images/ShrimpSpicyPorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/ShrimpSpicyPorkBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1000,
            carb: 110,
            protein: 32,
            fat: 46,
        }
    },
    {
        id: 11,
        category: '간편 도시락',
        name: '탕수육제육 도시락',
        subTitle: '인기 메뉴의 완벽한 콜라보, 오늘 하루를 보상하는 한끼',
        price: 11500,
        productImg: process.env.PUBLIC_URL + '/images/SweetSourPorkSpicyPorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SweetSourPorkSpicyPorkBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1100,
            carb: 120,
            protein: 34,
            fat: 50,
        }
    },
    {
        id: 12,
        category: '간편 도시락',
        name: '제육찌개한상 도시락',
        subTitle: '칼칼한 찌개와 매콤한 제육, 한국인이 가장 사랑하는 조합',
        price: 11000,
        productImg: process.env.PUBLIC_URL + '/images/SpicyPorkStewBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpicyPorkStewBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 880,
            carb: 90,
            protein: 36,
            fat: 34,
        }
    },
    {
        id: 13,
        category: '간편 도시락',
        name: '불백찌개한상 도시락',
        subTitle: '따끈한 국물에 달콤한 불고기, 몸과 마음을 녹이는 온기',
        price: 11000,
        productImg: process.env.PUBLIC_URL + '/images/BulgogiStewBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/BulgogiStewBox_Detail.png',
        isMD: true,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 900,
            carb: 92,
            protein: 38,
            fat: 35,
        }
    },
    {
        id: 14,
        category: '간편 도시락',
        name: '소불백찌개한상 도시락',
        subTitle: '깊은 국물과 소불고기의 품격, 체계적으로 차려낸 보양식',
        price: 12000,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogiStewBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogiStewBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount:250,
        nutrition: {
            kcal: 950,
            carb: 95,
            protein: 40,
            fat: 38,
        }
    },
    {
        id: 15,
        category: '간편 도시락',
        name: '알찬불백 도시락',
        subTitle: '가성비는 높이고 배는 든든하게, 실속파를 위한 선택',
        price: 7800,
        productImg: process.env.PUBLIC_URL + '/images/HeartyBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/HeartyBulgogiBox_Detail.png',
        isMD: true,
        defaultScore: 1000,
        cartCount: 150,       
        nutrition: {
            kcal: 720,
            carb: 85,
            protein: 30,
            fat: 25,
        }
    },
    {
        id: 16,
        category: '간편 도시락',
        name: '치킨불백 도시락',
        subTitle: '고소한 치킨과 달콤한 불백, 아이부터 어른까지 입맛 저격',
        price: 7300,
        productImg: process.env.PUBLIC_URL + '/images/ChickenBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenBulgogiBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 700,
            carb: 85,
            protein: 32,
            fat: 23,
        }
    },
    {
        id: 17,
        category: '간편 도시락',
        name: '알찬제육 도시락',
        subTitle: '부담 없이 즐기는 매콤한 한 끼, 꽉 찬 구성의 미학',
        price: 7800,
        productImg: process.env.PUBLIC_URL + '/images/HeartySpicyPorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/HeartySpicyPorkBox_Detail.png',
        isMD: true,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 750,
            carb: 88,
            protein: 31,
            fat: 27,
        }
    },
    {
        id: 18,
        category: '간편 도시락',
        name: '치킨제육 도시락',
        subTitle: '치킨과 제육의 거부할 수 없는 만남',
        price: 7300,
        productImg: process.env.PUBLIC_URL + '/images/ChickenSpicyPorkBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenSpicyPorkBox_Detail.png',
        isMD: false,
        defaultScore: 600,
        cartCount: 210,
        nutrition: {
            kcal: 820,
            carb: 92,
            protein: 33,
            fat: 30,
        }
    },
    {
        id: 19,
        category: '간편 도시락',
        name: '알찬소불백 도시락',
        subTitle: '소불고기의 풍미를 가볍게 즐기다, 가심비 완벽 공략',
        price: 8400,
        productImg: process.env.PUBLIC_URL + '/images/HeartyBeefBulgogiBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/HeartyBeefBulgogiBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 760,
            carb: 85,
            protein: 34,
            fat: 26,
        }
    },
    {
        id: 20,
        category: '간편 도시락',
        name: '소불백치킨 도시락',
        subTitle: '단짠의 정석 소불고기와 치킨의 앙상블, 즐거운 점심시간',
        price: 8000,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogChickenBox.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogChickenBox_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 780,
            carb: 88,
            protein: 35,
            fat: 27,
        }
    },
    {
        id: 21,
        category: '컵밥',
        name: '참치야채 비빔밥',
        subTitle: '신선한 야채와 고소한 참치, 입안 가득 터지는 산뜻함',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/TunaVeggieBibimbap.png',
        detailImg: process.env.PUBLIC_URL + '/images/TunaVeggieBibimbap_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 650,
            carb: 95,
            protein: 28,
            fat: 18,
        }
    },
    {
        id: 22,
        category: '컵밥',
        name: '묵은지김치찌개 세트',
        subTitle: '푹 익은 묵은지의 깊은 맛, 고향의 정성이 느껴지는 세트',
        price: 10000,
        productImg: process.env.PUBLIC_URL + '/images/AgedKimchiStew.png',
        detailImg: process.env.PUBLIC_URL + '/images/AgedKimchiStew_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 780,
            carb: 85,
            protein: 30,
            fat: 28,
        }
    },
    {
        id: 23,
        category: '컵밥',
        name: '부대찌개 세트',
        subTitle: '풍성한 햄과 진한 국물, 실패 없는 든든한 한끼',
        price: 10500,
        productImg: process.env.PUBLIC_URL + '/images/ArmyStew.png',
        detailImg: process.env.PUBLIC_URL + '/images/ArmyStew_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 900,
            carb: 90,
            protein: 34,
            fat: 38,
        }
    },
    {
        id: 24,
        category: '컵밥',
        name: '참치마요 컵밥',
        subTitle: '고소한 마요네즈와 참치의 꿀조합, 간편함 속 확실한 행복',
        price: 6500,
        productImg: process.env.PUBLIC_URL + '/images/TunaMayo.png',
        detailImg: process.env.PUBLIC_URL + '/images/TunaMayo_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 620,
            carb: 80,
            protein: 22,
            fat: 24,
        }
    },
    {
        id: 25,
        category: '컵밥',
        name: '스팸마요 컵밥',
        subTitle: '짭조름한 스팸의 거부할 수 없는 유혹, 자꾸 생각나는 그 맛',
        price: 6500,
        productImg: process.env.PUBLIC_URL + '/images/SpamMayo.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpamMayo_Detail.png',
        isMD: true,
        defaultScore: 900,
        cartCount: 160,        
        nutrition: {
            kcal: 680,
            carb: 82,
            protein: 20,
            fat: 30,
        }
    },
    {
        id: 26,
        category: '컵밥',
        name: '치킨마요 컵밥',
        subTitle: '바삭한 치킨과 부드러운 소스의 조화, 스테디셀러의 위엄',
        price: 6500,
        productImg: process.env.PUBLIC_URL + '/images/SpamMayo.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpamMayo_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 650,
            carb: 80,
            protein: 25,
            fat: 26,
        }
    },
    {
        id: 27,
        category: '컵밥',
        name: '떡갈비마요 컵밥',
        subTitle: '육즙 가득 떡갈비의 변신, 컵밥으로 즐기는 정통의 맛',
        price: 6800,
        productImg: process.env.PUBLIC_URL + '/images/HamburgerSteakMayo.png',
        detailImg: process.env.PUBLIC_URL + '/images/HamburgerSteakMayo_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 720,
            carb: 85,
            protein: 24,
            fat: 32,
        }
    },
    {
        id: 28,
        category: '컵밥',
        name: '치킨마요찌개한상 컵밥',
        subTitle: '컵밥에 찌개를 더한 완벽한 구성, 작지만 강한 만족감',
        price: 8900,
        productImg: process.env.PUBLIC_URL + '/images/ChickenMayoStew.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenMayoStew_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 880,
            carb: 90,
            protein: 32,
            fat: 36,
        }
    },
    {
        id: 29,
        category: '컵밥',
        name: '간장제육 덮밥',
        subTitle: '밥밥 위에 듬뿍 올린 간장제육, 한 그릇에 담긴 체계적 영양',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/SoySaucePork.png',
        detailImg: process.env.PUBLIC_URL + '/images/SoySaucePork_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 780,
            carb: 92,
            protein: 30,
            fat: 28,
        }
    },
    {
        id: 30,
        category: '컵밥',
        name: '고추장제육 덮밥',
        subTitle: '매콤한 양념이 쏙 배어든 제육, 쓱쓱 비벼 먹는 즐거움',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/SpicyPork.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpicyPork_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 820,
            carb: 95,
            protein: 30,
            fat: 28,
        }
    },
    {
        id: 31,
        category: '컵밥',
        name: '소불고기 덮밥',
        subTitle: '프리미엄 소불고기를 한 그릇에, 품격 있는 간편식',
        price: 8200,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogi.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogi_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 850,
            carb: 95,
            protein: 32,
            fat: 34,
        }
    },
    {
        id: 32,
        category: '컵밥',
        name: '소세지카레 덮밥',
        subTitle: '톡 터지는 소시지와 진한 카레, 아이 같은 동심의 맛',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/SausageCurry.png',
        detailImg: process.env.PUBLIC_URL + '/images/SausageCurry_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 880,
            carb: 105,
            protein: 25,
            fat: 38,
        }
    },
    {
        id: 33,
        category: '컵밥',
        name: '돈까스카레 덮밥',
        subTitle: '바삭한 돈까스와 카레의 만남, 든든함이 두 배가 되는 마법',
        price: 7900,
        productImg: process.env.PUBLIC_URL + '/images/SausageCurry.png',
        detailImg: process.env.PUBLIC_URL + '/images/SausageCurry_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1050,
            carb: 115,
            protein: 30,
            fat: 50,
        }
    },
    {
        id: 34,
        category: '컵밥',
        name: '카레 덮밥',
        subTitle: '정성을 다해 끓여낸 정통 카레, 기본에 충실한 깔끔함',
        price: 6500,
        productImg: process.env.PUBLIC_URL + '/images/CurryRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/CurryRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 720,
            carb: 105,
            protein: 18,
            fat: 22,
        }
    },
    {
        id: 35,
        category: '컵밥',
        name: '곤드레나물밥',
        subTitle: '향긋한 곤드레에 담백한 양념, 매일 먹어도 질리지 않는 건강한 한 그릇',
        price: 5500,
        productImg: process.env.PUBLIC_URL + '/images/GondreHerbRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/GondreHerbRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 620,
            carb: 105,
            protein: 18,
            fat: 14,
        }
    },
    {
        id: 36,
        category: '컵밥',
        name: '계란차돌깍두기 볶음밥',
        subTitle: '고소한 계란과 차돌의 감칠맛, 깍두기 볶음밥의 완벽한 단짠 조합',
        price: 7800,
        productImg: process.env.PUBLIC_URL + '/images/BeefEggRadishKimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefEggRadishKimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 880,
            carb: 95,
            protein: 28,
            fat: 38,
        }
    },
    {
        id: 37,
        category: '컵밥',
        name: '김치볶음밥 컵밥',
        subTitle: '잘 익은 김치로 볶아낸, 실패 없는 국민 볶음밥의 정석',
        price: 6900,
        productImg: process.env.PUBLIC_URL + '/images/KimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/KimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 750,
            carb: 100,
            protein: 20,
            fat: 38,
        }
    },
    {
        id: 38,
        category: '컵밥',
        name: '스팸김치볶음밥 컵밥',
        subTitle: '짭짤한 스팸과 김치의 조화, 한 숟갈마다 중독되는 맛',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/SpamKimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpamKimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 850,
            carb: 100,
            protein: 22,
            fat: 36,
        }
    },
    {
        id: 39,
        category: '컵밥',
        name: '소불고기김치볶음밥 컵밥',
        subTitle: '달콤한 불고기와 김치의 만남, 든든함이 다른 볶음밥',
        price: 8500,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogiKimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogiKimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 880,
            carb: 98,
            protein: 30,
            fat: 34,
        }
    },
    {
        id: 40,
        category: '컵밥',
        name: '치즈김치볶음밥 컵밥',
        subTitle: '고소한 치즈가 더해져 부드럽게 즐기는 단짠 김치볶음밥',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/CheeseKimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/CheeseKimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 900,
            carb: 95,
            protein: 24,
            fat: 40,
        }
    },
    {
        id: 41,
        category: '컵밥',
        name: '차돌깍두기볶음밥 컵밥',
        subTitle: '차돌의 풍미와 깍두기의 아삭함, 감칠맛 폭발 볶음밥',
        price: 8500,
        productImg: process.env.PUBLIC_URL + '/images/BeefRadishKimchiFriedRice.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefRadishKimchiFriedRice_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 860,
            carb: 95,
            protein: 26,
            fat: 36,
        }
    },
    {
        id: 42,
        category: '컵밥',
        name: '돈까스돈부리 컵밥',
        subTitle: '바삭한 돈까스에 달콤한 소스, 누구나 좋아하는 든든한 한 그릇',
        price: 9500,
        productImg: process.env.PUBLIC_URL + '/images/PorkCutletDonburi.png',
        detailImg: process.env.PUBLIC_URL + '/images/PorkCutletDonburi_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1000,
            carb: 110,
            protein: 32,
            fat: 48,
        }
    },
    {
        id: 43,
        category: '컵밥',
        name: '돈까스새우돈부리 컵밥',
        subTitle: '돈까스와 새우의 완벽한 조합, 골라 먹는 재미까지 더한 메뉴',
        price: 10000,
        productImg: process.env.PUBLIC_URL + '/images/PorkCutletDonburi.png',
        detailImg: process.env.PUBLIC_URL + '/images/PorkCutletDonburi_Detail.png',
        isMD: true,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 1100,
            carb: 115,
            protein: 34,
            fat: 52,
        }
    },
    {
        id: 44,
        category: '컵밥',
        name: '치킨돈부리 컵밥',
        subTitle: '촉촉한 치킨에 달콤짭짤한 소스, 부담 없이 즐기기 좋은 컵밥',
        price: 8000,
        productImg: process.env.PUBLIC_URL + '/images/ChickenDonburi.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenDonburi_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 920,
            carb: 105,
            protein: 30,
            fat: 38,
        }
    },
    {
        id: 45,
        category: '컵밥',
        name: '고추장제육 비빔밥',
        subTitle: '매콤달콤 제육과 고추장의 조화, 입맛 확 살아나는 한끼',
        price: 7500,
        productImg: process.env.PUBLIC_URL + '/images/SpicyPorkBibimbap.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpicyPorkBibimbap_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 820,
            carb: 100,
            protein: 28,
            fat: 30,
        }
    },
    {
        id: 46,
        category: '컵밥',
        name: '소불고기 비빔밥',
        subTitle: '달콤한 소불고기와 신선한 재료가 어우러진 균형 잡힌 비빔밥',
        price: 8200,
        productImg: process.env.PUBLIC_URL + '/images/BeefBulgogiBibimbap.png',
        detailImg: process.env.PUBLIC_URL + '/images/BeefBulgogiBibimbap_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 780,
            carb: 98,
            protein: 30,
            fat: 26,
        }
    },
    {
        id: 47,
        category: '샐러드',
        name: '닭가슴살 샐러드',
        subTitle: '담백한 닭가슴살과 신선한 채소로 가볍지만 든든한 한끼',
        price: 10400,
        productImg: process.env.PUBLIC_URL + '/images/ChickenBreastSalad.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenBreastSalad_Detail.png',
        isMD: true,
        defaultScore: 700,
        cartCount: 190,        
        nutrition: {
            kcal: 280,
            carb: 18,
            protein: 32,
            fat: 6,
        }
    },
    {
        id: 48,
        category: '샐러드',
        name: '단호박 샐러드',
        subTitle: '달콤한 단호박의 부드러운 식감, 누구나 부담 없이 즐기는 샐러드',
        price: 8800,
        productImg: process.env.PUBLIC_URL + '/images/SweetPumpkinSalad.png',
        detailImg: process.env.PUBLIC_URL + '/images/SweetPumpkinSalad_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 350,
            carb: 40,
            protein: 8,
            fat: 16,
        }
    },
    {
        id: 49,
        category: '샐러드',
        name: '리코타치즈 샐러드',
        subTitle: '고소한 리코타치즈와 상큼한 채소의 균형 잡힌 조합',
        price: 11900,
        productImg: process.env.PUBLIC_URL + '/images/RicottaCheeseSalad.png',
        detailImg: process.env.PUBLIC_URL + '/images/RicottaCheeseSalad_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 420,
            carb: 22,
            protein: 18,
            fat: 30,
        }
    },
    {
        id: 50,
        category: '샐러드',
        name: '치킨 샐러드',
        subTitle: '바삭한 치킨에 신선함을 더해 맛과 포만감을 모두 잡은 샐러드',
        price: 9900,
        productImg: process.env.PUBLIC_URL + '/images/ChickenSalad.png',
        detailImg: process.env.PUBLIC_URL + '/images/ChickenSalad_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 380,
            carb: 20,
            protein: 28,
            fat: 18,
        }
    },
    {
        id: 51,
        category: '샐러드',
        name: '훈제연어 샐러드',
        subTitle: '깊은 풍미의 훈제연어와 신선한 채소가 어우러진 프리미엄 샐러드',
        price: 14900,
        productImg: process.env.PUBLIC_URL + '/images/SmokedSalmonSalad.png',
        detailImg: process.env.PUBLIC_URL + '/images/SmokedSalmonSalad_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 400,
            carb: 18,
            protein: 26,
            fat: 26,
        }
    },
    {
        id: 52,
        category: '샐러드',
        name: '클랜즈쥬스',
        subTitle: '건강한 재료로 상쾌하게 즐기는 깔끔한 클렌즈',
        price: 2500,
        productImg: process.env.PUBLIC_URL + '/images/CleanseJuice.png',
        detailImg: process.env.PUBLIC_URL + '/images/CleanseJuice.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 160,
            carb: 38,
            protein: 3,
            fat: 1,
        }
    },
    {
        id: 53,
        category: '샐러드',
        name: '클랜즈쥬스 스칼렛',
        subTitle: '상큼한 과일 블렌딩으로 몸을 가볍게 리프레시해주는 클랜즈 쥬스',
        price: 3500,
        productImg: process.env.PUBLIC_URL + '/images/CleanseJuiceScarlet.png',
        detailImg: process.env.PUBLIC_URL + '/images/CleanseJuiceScarlet.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 170,
            carb: 40,
            protein: 3,
            fat: 1,
        }
    },
    {
        id: 54,
        category: '샐러드',
        name: '클랜즈쥬스 옐로우',
        subTitle: '달콤하고 부드러운 맛으로 부담 없이 즐기기 좋은 쥬스',
        price: 3500,
        productImg: process.env.PUBLIC_URL + '/images/CleanseJuiceYellow.png',
        detailImg: process.env.PUBLIC_URL + '/images/CleanseJuiceYellow.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 180,
            carb: 42,
            protein: 4,
            fat: 1,
        }
    },
    {
        id: 55,
        category: '샐러드',
        name: '콘스프',
        subTitle: '고소하고 달콤한 옥수수의 부드러운 클래식 스프',
        price: 3500,
        productImg: process.env.PUBLIC_URL + '/images/CornSoup.png',
        detailImg: process.env.PUBLIC_URL + '/images/CornSoup_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 220,
            carb: 28,
            protein: 6,
            fat: 10,
        }
    },
    {
        id: 56,
        category: '샐러드',
        name: '양송이 스프',
        subTitle: '진한 버섯 향이 살아 있는 깊고 담백한 크림 스프',
        price: 3500,
        productImg: process.env.PUBLIC_URL + '/images/MushroomSoup.png',
        detailImg: process.env.PUBLIC_URL + '/images/MushroomSoup_Detail.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 200,
            carb: 22,
            protein: 7,
            fat: 10,
        }
    },
    {
        id: 57,
        category: '샐러드',
        name: '유자 소스',
        subTitle: '상큼한 유자 향으로 샐러드를 산뜻하게 살려주는 소스',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/YuzaSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/YuzaSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 80,
            carb: 18,
            protein: 0,
            fat: 0,
        }
    },
    {
        id: 58,
        category: '샐러드',
        name: '양파크림 소스',
        subTitle: '부드러운 크림에 양파의 달콤함을 더한 고소한 소스',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/OnionCreamSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/OnionCreamSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 150,
            carb: 6,
            protein: 1,
            fat: 14,
        }
    },
    {
        id: 59,
        category: '샐러드',
        name: '스위트레몬 소스',
        subTitle: '달콤상큼한 레몬 풍미로 입맛을 깨워주는 소스',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/SweetLemonSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/SweetLemonSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 90,
            carb: 20,
            protein: 0,
            fat: 0,
        }
    },
    {
        id: 60,
        category: '샐러드',
        name: '오라엔탈 소스',
        subTitle: '깔끔하고 감칠맛 좋은 정통 오리엔탈 스타일',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/OrientalSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/OrientalSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 110,
            carb: 10,
            protein: 1,
            fat: 8,
        }
    },
    {
        id: 61,
        category: '샐러드',
        name: '발사믹 소스',
        subTitle: '깊은 산미와 은은한 단맛의 조화로운 발사믹 소스',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/BalsamicSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/BalsamicSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 70,
            carb: 15,
            protein: 0,
            fat: 0,
        }
    },
    {
        id: 62,
        category: '샐러드',
        name: '스파이시크림 소스',
        subTitle: '은근한 매콤함과 크리미한 고소함이 어우러진 중독성 있는 소스',
        price: 800,
        productImg: process.env.PUBLIC_URL + '/images/SpicyCreamSource.png',
        detailImg: process.env.PUBLIC_URL + '/images/SpicyCreamSource.png',
        isMD: false,
        defaultScore: 400,
        cartCount: 250,
        nutrition: {
            kcal: 160,
            carb: 6,
            protein: 1,
            fat: 15,
        }
    },
]

export default products;